import type { LogTarget } from "@/features/time/lib/timesheet";

/** Where some time belongs: its task (opened over the project's board) or its project. */
export function targetLink(target: LogTarget): string {
  const project = `/projects/${target.project.key}`;
  return target.task ? `${project}?task=${encodeURIComponent(target.task.reference)}` : project;
}
